// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/share.js';

import { paths } from '../generated/share';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('share', Original, paths);
